/**
 * Fair-use limits and telephony wallet rules shown on the pricing section and
 * in the Terms (§ Fair use, § Telephony). Display copy only — the enforced
 * values live in the backend (`config/saas-plans.js`, `config/telephony-pricing.js`);
 * keep both in sync when either changes.
 */
export type FairUseCaps = {
  callDocs: number;
  transcriptionMin: number;
  recordingMin: number;
};

export const FAIR_USE: {
  trial: FairUseCaps;
  solo: FairUseCaps;
  teamPerSeat: FairUseCaps;
  warnPct: number;
  changeNoticeDays: number;
} = {
  /** During the 14-day trial (either plan), per calendar month like the paid plans (a trial touches at most two). */
  trial: { callDocs: 50, transcriptionMin: 200, recordingMin: 200 },
  /** Paid Solo, absolute per calendar month. */
  solo: { callDocs: 1000, transcriptionMin: 2000, recordingMin: 3000 },
  /** Paid Team, per seat per calendar month (pooled across the team). */
  teamPerSeat: { callDocs: 3000, transcriptionMin: 6000, recordingMin: 10000 },
  warnPct: 80,
  changeNoticeDays: 30,
};

export const TELEPHONY = {
  /** 20 % since 2026-09-28 (was 15): covers Paddle's share of every top-up. Backend TELEPHONY_MARKUP_PCT. */
  serviceFeePct: 20,
  /** USD→EUR conversion buffer on top of the ECB reference rate. */
  fxBufferPct: 2,
  starterCreditEur: 3,
  minTopupEur: 10,
  maxTopupEur: 1000,
  numberGraceDays: 7,
} as const;

export const fmtInt = (n: number, locale: string): string =>
  new Intl.NumberFormat(locale === "de" ? "de-DE" : "en-US").format(n);
